import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { RefCategorie } from './ref-categorie.model';
import { RefMouvement } from '../../declaration/models/ref-mouvement.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Document {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' },
        template: { key: 'template', optional: true, default: '' },
        idOrganisme: { key: 'idOrganisme', optional: true },
        refCategorie: { key: 'idRefCategorie', converter: new (DataIdConverterFactory.build(RefCategorie, 'refCategorieList'))(), optional: true },
        isMailable: { key: 'isMailable', optional: true },
        isIndividuel: { key: 'isIndividuel', optional: true },
        isEntete: { key: 'isEntete', optional: true },
        isPaysage: { key: 'isPaysage', optional: true },
        useByOperateur: { key: 'useByOperateur', optional: true },
        idRefMouvement: { key: 'idRefMouvement', optional: true }
    };

    id: number;
    libelle: string;
    template: string;
    idOrganisme: number;
    refCategorie: RefCategorie;
    isMailable: boolean;
    isIndividuel?: boolean;
    isEntete?: boolean;
    isPaysage?: boolean;
    useByOperateur?: boolean;
    idRefMouvement: number;

    mouvement: RefMouvement;
    checked?: boolean;
}
